import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar is-transparent" }
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://i.imgur.com/uA3fRLZ.png",
  alt: "Bulma: a modern CSS framework based on Flexbox",
  height: "28"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "navbar-burger",
  "data-target": "navbarExampleTransparentExample"
}, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_5 = {
  id: "navbarExampleTransparentExample",
  class: "navbar-menu"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "navbar-start" }, null, -1)
const _hoisted_7 = { class: "navbar-end" }
const _hoisted_8 = { class: "navbar-item" }
const _hoisted_9 = { class: "field is-grouped" }
const _hoisted_10 = { class: "control" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "w-6 h-6"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.636 5.636a9 9 0 1012.728 0M12 3v9"
    })
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Logout", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "navbar-item"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, [
              _createElementVNode("a", {
                class: "button is-danger is-outlined",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.doLogout && _ctx.doLogout(...args)))
              }, [
                _hoisted_11,
                _createTextVNode("   "),
                _hoisted_12
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}